import { useEffect, useState } from "react";
import api from "../../api/axios";
import dayjs from "dayjs";
import MainLayout from "../layoutpage/MainLayout";
import Footer from "../../components/Footer";

export default function OverdueBookingList({ user, onLogout }) {
  user = JSON.parse(localStorage.getItem("user"));
  const [bookings, setBookings] = useState([]);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const [method, setMethod] = useState("percentage");
  const [value, setValue] = useState("");
  const [calculatedFee, setCalculatedFee] = useState(0);

  useEffect(() => {
    fetchBookings();
  }, []);

  const fetchBookings = async () => {
    const res = await api.get("/api/overdue-bookings");
    const today = dayjs();

    // filter — check_out_date < today
    const overdue = res.data.data.filter((b) =>
      dayjs(b.check_out_date).isBefore(today)
    );
    console.log("Overdue", overdue);
    setBookings(overdue);
  };

  // modal open
  const openModal = (booking) => {
    console.log("selected booking", booking);
    setSelectedBooking(booking);
    setValue("");
    setCalculatedFee(0);
    setShowModal(true);
  };

  // calculate late fee
  const calculateLateFee = () => {
    if (!selectedBooking) return;

    const dueAmount = selectedBooking.due_amount;

    if (method === "percentage") {
      setCalculatedFee((dueAmount * (value / 100)).toFixed(2));
    } else {
      setCalculatedFee(parseFloat(value).toFixed(2));
    }
  };

  const submitLateFee = async () => {
    const payload = {
      booking_id: selectedBooking.id,
      calculation_method: method,
      calculation_rate: value,
      calculated_fee: calculatedFee,
    };

    await api.post("/api/late-fees", payload);

    alert("Late fee applied!");
    setShowModal(false);
    fetchBookings();
  };

  return (
    <>
      <div className="container mt-5 ">
        <h2
          className="text-center mb-4 text-primary fw-bold"
          style={{ textDecoration: "underline", color: "blue" }}
        >
          Overdue Bookings (Late Fee)
        </h2>
        <div className="table-responsive">
          {" "}
          <table className="table table-bordered table-striped">
            <thead className="table-primary">
              <tr>
                <th>ID</th>
                <th>Property</th>
                <th>Unit</th>
                <th>User</th>
                <th>Check-Out</th>
                <th>Due Amount</th>
                <th>Days Overdue</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {bookings.map((b) => {
                const daysOverdue = dayjs().diff(
                  dayjs(b.check_out_date),
                  "day"
                );

                return (
                  <tr key={b.id}>
                    <td>{b.id}</td>
                    <td>{b.property?.name}</td>
                    <td>{b.unit?.unit_number}</td>
                    <td>{b.user?.name}</td>
                    <td>{dayjs(b.check_out_date).format("DD/MM/YYYY")}</td>
                    <td>{b.due_amount}</td>
                    <td style={{ color: "red", fontWeight: "bold" }}>
                      {daysOverdue} days
                    </td>
                    <td>
                      <button
                        className="btn btn-warning btn-sm"
                        onClick={() => openModal(b)}
                      >
                        Apply Late Fee
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        {/* MODAL */}
        {showModal && (
          <div
            className="modal fade show d-block"
            style={{ background: "#0004" }}
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Apply Late Fee</h5>
                  <button
                    className="btn-close"
                    onClick={() => setShowModal(false)}
                  ></button>
                </div>

                <div className="modal-body">
                  <p>
                    <b>Booking ID:</b> {selectedBooking?.id} <br />
                    <b>Due Amount:</b> {selectedBooking?.due_amount}
                  </p>

                  <div className="mb-3">
                    <label className="form-label">Fee Method</label>
                    <select
                      className="form-select"
                      value={method}
                      onChange={(e) => setMethod(e.target.value)}
                    >
                      <option value="percentage">Percentage (%)</option>
                      <option value="fixed">Fixed Amount</option>
                    </select>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">
                      {method === "percentage" ? "Percentage %" : "Amount"}
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      value={value}
                      onChange={(e) => setValue(e.target.value)}
                      onKeyUp={calculateLateFee}
                    />
                  </div>

                  <div className="alert alert-info">
                    <b>Calculated Late Fee:</b> {calculatedFee}
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowModal(false)}
                  >
                    Close
                  </button>
                  <button className="btn btn-primary" onClick={submitLateFee}>
                    Apply Fee
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
